/**
 * Preprod environment configuration
 */
import type { Config } from './default';

const config: Partial<Config> = {
  descope: {
    // Preprod environment
    pharmacyPortal: {
      flowId: 'sign-in-pharmacist',
      tenant: '',
    },
    projectId: 'P2oAuew8XQsqrJvfcGhOKc01aLmU',
  },
  statsig: {
    // Client-side SDK key for development environment
    sdkKey: 'client-CEVqp32NixFG4IrlVFy8mrgNwWex1bkCTEYxMZdFp5S',
    environment: 'staging',
  },
  isProduction: false,
};

export default config;
